import { query, getPreloaderFnContext } from '@confluence/query-preloader-tools';

import { ShareAndRestrictButtonQuery } from '../graphql/ShareAndRestrictButtonQuery.graphql';

export async function preloadShareAndRestrictButtonQuery(contentId: string) {
	const { isLoggedIn } = await getPreloaderFnContext();

	if (!isLoggedIn) {
		return;
	}

	return query({
		query: ShareAndRestrictButtonQuery,
		variables: {
			contentId,
			isContentTypePublicLinkEligible: true,
		},
	});
}
